/* eslint-disable max-len */
import React from 'react'

const SeeMoreIcon = ({ color }: { color: string }) => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M19.998 11.2686C20.0273 10.8745 19.7332 10.5321 19.3401 10.5021C18.9468 10.4721 18.6035 10.7667 18.5737 11.1602C18.2356 15.5962 14.483 19.0714 10.0301 19.0714C5.3037 19.0714 1.4587 15.2264 1.4587 10.5C1.4587 5.77357 5.3037 1.92857 10.0301 1.92857C12.4989 1.92857 14.7985 2.97833 16.412 4.78571H14.3158C13.9213 4.78571 13.6016 5.10548 13.6016 5.5C13.6016 5.89452 13.9213 6.21429 14.3158 6.21429H18.6016V1.92857C18.6016 1.53405 18.2818 1.21429 17.8873 1.21429C17.4928 1.21429 17.173 1.53405 17.173 1.92857V3.50643C15.3113 1.59857 12.7592 0.5 10.0301 0.5C4.51608 0.5 0.0301323 4.98595 0.0301323 10.5C0.0301323 16.014 4.51608 20.5 10.0301 20.5C15.2254 20.5 19.6037 16.445 19.998 11.2686Z'
      fill={color}
    />
  </svg>
)

export default SeeMoreIcon
